import { EClickMode, EClickRankType, EClickType, EHeatmapType } from '@gem-sdk/heatmap-react';

/**
 * Default click type and ranked by
 */
export const HEATMAP_CLICK_CONFIG = {
  CLICK_TYPE: EClickType.All,
  CLICK_MODE: EClickMode.Default,
  RANKED_BY: EClickRankType.MostClicks,
};

export const HEATMAP_TYPE_CONFIG = {
  HEATMAP_TYPE: EHeatmapType.Click,
};
